export default __webpack_public_path__ + "static/media/Armbands of Vengeful Zeal.343c7851.jpg";